import { useParams } from 'react-router-dom';

import AuditHistoryAccordion from './AuditHistoryAccordion';
import Layout from './Layout';
import { useGetAssetBankStatmentAuditHistory } from './hooks';

export default function AssetBankStatementAuditHistory() {
  const { assetId, documentId } = useParams();

  const {
    data: auditHistory,
    isLoading,
    isError,
  } = useGetAssetBankStatmentAuditHistory(assetId, documentId);

  const pageTitle = 'Asset_Bank_Statement';

  return (
    <Layout
      pageEnum={pageTitle}
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!auditHistory?.length}
    >
      <AuditHistoryAccordion data={auditHistory} />
    </Layout>
  );
}
